@if (positionsForShow?.length) {
  <div class="profile-info small">
    @if (revealed) {
      <div class="profile-info__decoration">
        <div class="profile-info__icon-wrapper">
          <img
            alt="Experience"
            src="assets/images/icons/briefcase.svg"
            width="16"
            height="16"
            class="icon" />
        </div>
      </div>
    }
    <div class="profile-experiences profile-info__content">
      @for (position of positionsForShow; track position) {
        <div class="profile-experience">
          <h3 class="experience-position">
            {{ position.positionTitle }}
          </h3>
          @if (position.positionTitle) {
            <h3 class="experience-separator">—</h3>
          }
          @if (position.companyName) {
            <span class="company-name">
              {{ position.companyName }}
              @if (position.location?.city || position.location?.country) {
                <span>,</span>
              }
              {{ position.location?.city }}
              @if (position.location?.city && position.location?.country) {
                <span>,</span>
              }
              {{ position.location?.country }}
            </span>
          } @else {
            <span class="company-name">
              {{ 'CANDIDATE.SOMEWHERE' | translate }}
              @if (position.location?.city || position.location?.country) {
                <span>,</span>
              }
              {{ position.location?.city }}
              @if (position.location?.city && position.location?.country) {
                <span>,</span>
              }
              {{ position.location?.country }}
            </span>
          }
          <span class="experience-duration">
            <app-period-range
              [duration]="position.duration"
              [durationType]="'short'"
              [styleType]="'bold'"
              [withDateRange]="true"></app-period-range>
          </span>
        </div>
      }
    </div>
  </div>
}
